export enum ImportModalPageType {
  Upload = "upload",
  ImportHistory = "history",
  ImportDataTable = "details"
}
